import React from 'react';
import './NavLink.css'

const NavLink = (props) => {
    return ( 
        <a className={props.NavLinkClass} href="../../Pages/Home.jsx">{props.NavLinkText}</a>
     );
}
 
export default NavLink;